import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ResumenEstadisticasHallazgosService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Informe/ResumenEstadisticasHallazgosPorAreaNegocio",
            values, customConfig
        );
        return resultado
    } catch (error) {
        console.log(error);
    }
}
export { ResumenEstadisticasHallazgosService };